module.exports = __webpack_public_path__ + "assets/img/block-right-47ebe0a2.png";